import React from "react";
import throttle from "lodash.throttle";

export const useScrollVisibility = (
  setIsVisible: (state: boolean) => void,
  deps: React.DependencyList = [],
) => {
  React.useEffect(() => {
    const handleScroll = throttle(() => {
      const scrollPosition = window.scrollY;
      const viewportHeight = window.innerHeight;
      const scrollThreshold = viewportHeight * 0.9;
      const state = scrollPosition >= scrollThreshold;

      setIsVisible(state);
    }, 250);

    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      handleScroll.cancel(); // Cancel any pending throttled calls
    };
  }, deps);
};
